import { masks, onlyNumbersLetters } from 'components/label/masks'
import * as React from 'react'

import { MaskedField, MaskedFieldProps } from '../final-form'

export const ContraChaveField = (props: MaskedFieldProps) => {
  return <MaskedField mask={masks.contra_chave} parse={onlyNumbersLetters} {...props} />
}
